import axios from "axios";
import { getCookie } from "../../utils/helpers";

export const state = {
  token: getCookie('api_token'),
  is_error_server: false
};
export const mutations = {
  setIsErrorServer(state, value) {
    state.is_error_server = value;
  }
}
export const getters = {
  isLoggedIn: state => !!state.token,
}

export const actions = {
  authenticate({ dispatch, commit }, submitData) {
    return axios
        .post(appUrl + "/api/authenticate",  submitData,{
          headers: { Authorization: "Bearer auth sau" },
        })
        .then((res) => {
          return res;
        })
        .catch((error) => {
          throw error;
        });
  }
};
